import {
  withTranslation,
} from 'react-i18next';

import AdminRegattaPaymentDiscountsPageView from './AdminRegattaPaymentDiscountsPageView';

const TranslatedComponent = withTranslation()(AdminRegattaPaymentDiscountsPageView);

const Component = TranslatedComponent;

export default Component;
